import React from 'react';
import PropTypes from 'prop-types';
import styles from '../css/ImageAlbum.module.css';
import img from '../albums.png';
import { useDispatch } from 'react-redux';
import { photofolioActions } from '../redux/reducers/reducers';

const ImageAlbum = ({ album, index }) => {
    const dispatch = useDispatch();

    const handleAlbumToggle = () => {
        dispatch(photofolioActions.handleAlbumToggle());
    };

    const dispalyImages = () => {
        dispatch(photofolioActions.setcurrentAlbumOBJ(index));
    };

    const currImagesForSlidesHandle = () => {
        dispatch(photofolioActions.currImagesForSlidesHandle(album));
    };

    const onClickHandle = () => {
        handleAlbumToggle();
        dispalyImages();
        currImagesForSlidesHandle();
    };

    return (
        <div className={styles.container} onClick={onClickHandle}>
            <img src={img} className={styles.img} alt='img' />
            <span className={styles.text}>{album.text}</span>
        </div>
    );
};

ImageAlbum.propTypes = {
    album: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
};

export default ImageAlbum;
